module.exports = __webpack_public_path__ + "img/manchester-city.4576a8ef.png";